module.exports = __webpack_public_path__ + "img/invitation_mode_2.51095168.png";